export var ActionKeys;
(function (ActionKeys) {
    ActionKeys["VIEW_FILE"] = "VIEW/FILE";
})(ActionKeys || (ActionKeys = {}));
export function viewFile(name, content) {
    return {
        type: ActionKeys.VIEW_FILE,
        payload: {
            name,
            content
        }
    };
}
//# sourceMappingURL=actions.js.map